export const buildDataUrlFromBase64 = (
  base64ImageData: string,
  imageFormat = "jpeg"
): string => `data:image/${imageFormat};base64,${base64ImageData}`;
